import '@fontsource/archivo-black/400.css';
import '@fontsource/pixelify-sans/400.css';
import '@fontsource/pixelify-sans/700.css';
import '@fontsource/vt323/400.css';
import './styles/base.css';
import './styles/game.css';
import './styles/screens.css';
import './styles/fight.css';
import { App } from './app/App';

function boot(): void {
  const root = document.getElementById('app');
  if (!root) throw new Error('#app root element missing');
  root.replaceChildren();
  new App(root);
}

// Fonts are drawn into canvases too, so wait for them before the first frame.
const fontsReady = document.fonts?.ready ?? Promise.resolve();
void Promise.race([fontsReady, new Promise((r) => setTimeout(r, 1500))]).then(boot);
